var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.162,
    viewBox: "0 0 20.001 20.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M12,2A10,10,0,0,1,22,12a10,10,0,1,1-20,.324L2,12l0-.28A10,10,0,0,1,12,2Zm0,9H11l-.117.007a1,1,0,0,0,0,1.986L11,13v3l.007.117a1,1,0,0,0,.876.876L12,17h1l.117-.007a1,1,0,0,0,.876-.876L14,16l-.007-.117a1,1,0,0,0-.764-.857l-.112-.02L13,15V12l-.007-.117a1,1,0,0,0-.876-.876Zm.01-3-.127.007a1,1,0,0,0,0,1.986L12,10l.127-.007a1,1,0,0,0,0-1.986Z",
    transform: "translate(-2 -2)",
    fill: "#807ce0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleSm);
export default __webpack_public_path__ + "static/media/info-circle-sm.e0d9b74b9098b04b239e73857eb0cfdf.svg";
export { ForwardRef as ReactComponent };